import React from 'react';
import BasicNavBar from '../Core/BasicNavBar';

// TODO: import '../../../common/styles/general.scss';

/**
 * This layout handles all user pages. 
 */
class UserLayout extends React.Component {

    render() {
        return (
            <div>
                <BasicNavBar />
                <div className="row justify-content-center">
                    <div className="col-5 mt-5">
                        {this.props.children}
                    </div>
                </div>
            </div>
        );
    }
}

export default UserLayout;